import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const PopOutPortal = ({ children, onUnload }) => {
  const [popoutWindow, setPopoutWindow] = useState(null);
  const [popoutElement, setPopoutElement] = useState(null);
  let portalWindow = null;

  const copyStyles = (sourceDoc, targetDoc) => {
    Array.from(sourceDoc.styleSheets).forEach(styleSheet => {
      try {
        if (styleSheet.cssRules) {
          const newStyleEl = sourceDoc.createElement('style');
  
          Array.from(styleSheet.cssRules).forEach(cssRule => {
            newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText));
          });
  
          targetDoc.head.appendChild(newStyleEl);
        } else {
          const newLinkEl = sourceDoc.createElement('link');
  
          newLinkEl.rel = 'stylesheet';
          newLinkEl.href = styleSheet.href;
          targetDoc.head.appendChild(newLinkEl);
        }
      } catch (e) {
        // Error trying to transport styles between windows
        console.log('Error cloning styles in pop out portal', e);
      }
    });
  }

  const setupPopoutPortal = () => {
    const newWindow = window.open('', '', 'width=823,height=500');
    portalWindow = newWindow;
    setPopoutWindow(newWindow);

    // Listen for user manually closing window and update accordingly
    newWindow.onbeforeunload = () => {
      onUnload();
    };

    copyStyles(document, newWindow.document);
    newWindow.document.title = 'A React portal window';

    const newElement = document.createElement('div');
    newWindow.document.body.appendChild(newElement);

    setPopoutElement(newElement);
  }

  useEffect(() => {
    setupPopoutPortal();
    return () => {
      portalWindow.close();
    }
  }, []); // eslint-disable-line

  if (!popoutElement) {
    return null;
  }
  return ReactDOM.createPortal(children, popoutElement);
}

export default PopOutPortal;
